import { Alert, Box, Button, Container, Grid, IconButton, List, ListItem, ListItemText, Paper, Snackbar, Tab, Tabs, TextField, Typography } from '@mui/material'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import React, { useState } from 'react'
import { answerQuestion, createFaq, deleteFaq, fetchFAQs, fetchUserQuestions, updateFaq } from './hooks/hooks';
import { Add, ArrowBack, Delete, Edit} from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';


// Validation Schema using Yup
const validationSchema = Yup.object({
    question: Yup.string()
      .required('Question is required'),
    answer: Yup.string()
      .required('Answer is required')
      .min(50, 'Content must be at least 50 characters'),
  });
function Guide() {
  const [tabValue, setTabValue] = useState(0);
  const queryClient = useQueryClient();
  const [selectedItem, setSelectedItem] = useState(null);
  const [open, setOpen] = useState({ create: false, update: false });
      // const [formData, setFormData] = useState({ title: "", content: "", image: null });
      // const [formDataEdit, setFormDataEdit] = useState({ title: "", content: "", image: null  });
  const [toast, setToast] = useState({ open: false, message: "", severity: "" });

  // Fetch FAQs and user questions
  const { data: faqs, isLoading: isFAQsLoading, error: faqsError, refetch:faqRefetch} = useQuery({
         queryKey: ['faqs'],
         queryFn: fetchFAQs,
     });
  const { data: userQuestions, isLoading: isUserQuestionsLoading, error: userQuestionsError } = useQuery({
        queryKey:['userQuestions'],
        queryFn: fetchUserQuestions,
    });

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const mutation = useMutation({
    mutationFn: createFaq, // Ensure `createNews` is a function
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ["newFaq"] }); // Uncomment if needed
    //   setFormData({ title: "", content: "", image: null });
      setOpen({ create: false, update: false});
      setToast({ open: true, message: "News FAQ successfully!", severity: "success" });
       faqRefetch()
    },
    onError: (error) => {
      setToast({ open: true, message: "Failed to add news. Try again.", severity: "error" });
    }
  });

  
  const answerMutation = useMutation({
    mutationFn: answerQuestion,
    onSuccess: () => {
      queryClient.invalidateQueries(['userQuestions']);
      // setOpen({ create: false, update: false, detail:false });
      setToast({ open: true, message: "Answer Added successfully!", severity: "success" });
    },
    onError: (error) => {
      setToast({ open: true, message: "Failed to add Answer. Try again.", severity: "error" });
    }
})

  // Update News Mutation
      const updateMutation = useMutation({
          mutationFn: updateFaq,
          onSuccess: () => {
              queryClient.invalidateQueries(["faqUpdate"]);
              // setFormDataEdit({ title: "", content: "", image: null });
              setOpen({ create: false, update: false, detail:false });
              setToast({ open: true, message: "FAQ updated successfully!", severity: "success" });
          },
          onError: (error) => {
            setToast({ open: true, message: "Failed to update FAQ. Try again.", severity: "error" });
          }
      });
  
      // Delete News Mutation
      const deleteMutation = useMutation({
          mutationFn: deleteFaq,
          onSuccess: () => {
              queryClient.invalidateQueries(["faqDelete"]);
              setToast({ open: true, message: "FAQ deleted successfully!", severity: "success" });
          },
          onError: (error) => {
              setToast({ open: true, message: "Failed to delete FAQ. Try again.", severity: "error" });
          }
      });

      const upformik = useFormik({
        initialValues: {
            question: '',
            answer: '',
          },
          validationSchema: validationSchema,
          onSubmit: (values) => { 
            if (selectedItem.id) {
            updateMutation.mutate({ id: selectedItem.id, data: values });
          }
          },
        });

  const formik = useFormik({
    initialValues: {
      title: '',
      content: '',
      image: null,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      mutation.mutate(values);
    },
  });

  const handleOpenUpdateDrawer = (item) => {
    setSelectedItem(item);
    // Update formik values dynamically
  upformik.setValues({
    question: item.question || '',
    answer: item.answer || '',
  });
    setOpen({ create: false, update: true });
  };

  // Function to toggle create drawer
  const toggleDrawer = (type, state) => () => {
    setOpen({ create: type === "create" ? state : false, update: type === "update" ? state : false });
   
  };

       // Handle delete
   const handleDelete = (id) => {
        deleteMutation.mutate(id);
    };

    const handleAnswer = (id, answer) => {
      answerMutation.mutate({ id, answer });
    };
    
    
  if (isFAQsLoading || isUserQuestionsLoading) {
    return (
        <Container sx={{ textAlign: "center", marginTop: 5 }}>
            <Typography>Loading...</Typography>
        </Container>
    );
}

if (faqsError) {
    return (
        <Container sx={{ textAlign: "center", marginTop: 5 }}>
           <Typography color="error">Error: {faqsError.message}</Typography>
            {/* <Typography variant="h6" color="error">
                Error fetching news. Please try again later.
            </Typography> */}
        </Container>
    );
}
if (userQuestionsError) {
  return (
      <Container sx={{ textAlign: "center", marginTop: 5 }}>
         <Typography color="error">Error: {userQuestionsError.message}</Typography>
          {/* <Typography variant="h6" color="error">
              Error fetching news. Please try again later.
          </Typography> */}
      </Container>
  );
}

  return (
    <Container>
       <Paper elevation={0} style={{}}>
      {/* <Typography variant="h4" gutterBottom>Admin Panel</Typography> */}
      <Tabs
      
      indicatorColor="#001f3f"
      textColor="#001f3f"
        sx={{
          backgroundColor:"#e8e8e8",
          marginBottom: '20px',
          '& .MuiTabs-indicator': {
            backgroundColor: '#001f3f', // Custom indicator color
          },
        }}
      value={tabValue}
      onChange={handleTabChange}
      >
        <Tab
          sx={{
            fontSize:10,
            fontWeight: 'bold',
            color: tabValue === 0 ? '#001f3f' : 'gray', // Active tab color
            '&:hover': {
              color: '#001f3f', // Hover color
            },
          }}  label="FAQs" />
        <Tab 
          label="User Questions"
          sx={{
            fontSize:10,
            fontWeight: 'bold',
            color: tabValue === 1 ? '#001f3f' : 'gray', // Active tab color
            '&:hover': {
              color: '#001f3f', // Hover color
            },
          }}
        />
      </Tabs>
      <Box hidden={tabValue !== 0}>
        {
          faqs?.length === 0 ? (
            <Container maxWidth="md">
              <Box
                sx={{
                  mt: "4px",
                  p: "4px",
                  // borderRadius: 2,
                  boxShadow: 0,
                  backgroundColor: 'background.paper',
                }}
              >
                <Typography variant="h4" sx={{ fontWeight: 700, color: "#001f3f", fontSize:12, textTransform:"uppercase" }}>
                  New Frequently Asked Question (Guides)
                </Typography>
                <Typography variant="body1" sx={{mb:2, color: "text.secondary", fontSize: 10, textTransform:"capitalize" }}>
                  Create a new FAQ to assist users with common queries.
                </Typography>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={3}>
                    {/* Title Field */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Question"
                        name="question"
                        // margin='normal'
                        value={formik.values.question}
                        onChange={formik.handleChange}
                        error={formik.touched.question && Boolean(formik.errors.question)}
                        helperText={formik.touched.question && formik.errors.question}
                        InputLabelProps={{
                          sx: {
                            color: "#555", // Default label color
                            fontSize: 10,
                            transition: "color 0.3s ease",
                            "&:hover": {
                                color: "#333"
                            }, // Label color on hover
                            "&.Mui-focused": { 
                                color: "#001f3f",
                                textTransform:"uppercase",
                                fontWeight:500
                            }, // Label color on focus
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: 10, // Field content size
                            color: "#333", // Field content color
                            "&::placeholder": {
                              color: "#aaa", // Placeholder color
                              fontSize: 10,
                            },
                          },
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: "2px",
                            "&.Mui-focused fieldset": { 
                                borderColor: "#001f3f",
                                borderRadius:"2px"
                            }, // Focus border
                          },
                          '& .MuiFormHelperText-root': {
                            fontSize: 9, // Smaller font size for validation errors
                            color: 'error.main', // Red color for errors
                            textTransform:"capitalize"
                          },
                        
                        }}
                      />
                    </Grid>
        
                    {/* Content Field */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size='small'
                        label="Answer"
                        name="answer"
                        value={formik.values.answer}
                        onChange={formik.handleChange}
                        error={formik.touched.answer && Boolean(formik.errors.answer)}
                        helperText={formik.touched.answer && formik.errors.answer}
                        // margin="normal"
                        multiline
                        rows={4}
                        InputLabelProps={{
                          sx: {
                            color: "#555", // Default label color
                            fontSize: 10,
                            transition: "color 0.3s ease",
                            "&:hover": {
                                color: "#333"
                            }, // Label color on hover
                            "&.Mui-focused": { 
                                color: "#001f3f",
                                textTransform:"uppercase",
                                fontWeight:500
                            }, // Label color on focus
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: 10, // Field content size
                            color: "#333", // Field content color
                            "&::placeholder": {
                              color: "#aaa", // Placeholder color
                              fontSize: 10,
                            },
                          },
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: "2px",
                            "&.Mui-focused fieldset": { 
                                borderColor: "#001f3f",
                                borderRadius:"2px"
                            }, // Focus border
                          },
                          '& .MuiFormHelperText-root': {
                            fontSize: 9, // Smaller font size for validation errors
                            color: 'error.main', // Red color for errors
                            textTransform:"capitalize"
                          },
                        }}
                      />
                    </Grid>
        
                    {/* Submit Button */}
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        sx={{
                          borderRadius: "2px",
                          textTransform: 'none',
                          py: 1.5,
                          fontSize: 10,
                          boxShadow:0,
                          backgroundColor:"#001f3f",                  
                          "&:hover": {
                              boxShadow: "none",
                          },
                        }}
                      >
                        Add New FAQ
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Container>
          ):(
            open.create?(
              <Container maxWidth="md">
                <IconButton
                    onClick={toggleDrawer("create", false)}
                >
                    <ArrowBack/>
                </IconButton>
              <Box
                sx={{
                  mt: "4px",
                  p: "4px",
                  // borderRadius: 2,
                  boxShadow: 0,
                  backgroundColor: 'background.paper',
                }}
              >
                <Typography variant="h4" sx={{ fontWeight: 700, color: "#001f3f", fontSize:12, textTransform:"uppercase" }}>
                  New Frequently Asked Question (Guides)
                </Typography>
                <Typography variant="body1" sx={{mb:2, color: "text.secondary", fontSize: 10, textTransform:"capitalize" }}>
                  Create a new FAQ to assist users with common queries.
                </Typography>
                <form onSubmit={formik.handleSubmit}>
                  <Grid container spacing={3}>
                    {/* Title Field */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Question"
                        name="question"
                        // margin='normal'
                        value={formik.values.question}
                        onChange={formik.handleChange}
                        error={formik.touched.question && Boolean(formik.errors.question)}
                        helperText={formik.touched.question && formik.errors.question}
                        InputLabelProps={{
                          sx: {
                            color: "#555", // Default label color
                            fontSize: 10,
                            transition: "color 0.3s ease",
                            "&:hover": {
                                color: "#333"
                            }, // Label color on hover
                            "&.Mui-focused": { 
                                color: "#001f3f",
                                textTransform:"uppercase",
                                fontWeight:500
                            }, // Label color on focus
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: 10, // Field content size
                            color: "#333", // Field content color
                            "&::placeholder": {
                              color: "#aaa", // Placeholder color
                              fontSize: 10,
                            },
                          },
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: "2px",
                            "&.Mui-focused fieldset": { 
                                borderColor: "#001f3f",
                                borderRadius:"2px"
                            }, // Focus border
                          },
                          '& .MuiFormHelperText-root': {
                            fontSize: 9, // Smaller font size for validation errors
                            color: 'error.main', // Red color for errors
                            textTransform:"capitalize"
                          },
                        
                        }}
                      />
                    </Grid>
        
                    {/* Content Field */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size='small'
                        label="Answer"
                        name="answer"
                        value={formik.values.answer}
                        onChange={formik.handleChange}
                        error={formik.touched.answer && Boolean(formik.errors.answer)}
                        helperText={formik.touched.answer && formik.errors.answer}
                        // margin="normal"
                        multiline
                        rows={4}
                        InputLabelProps={{
                          sx: {
                            color: "#555", // Default label color
                            fontSize: 10,
                            transition: "color 0.3s ease",
                            "&:hover": {
                                color: "#333"
                            }, // Label color on hover
                            "&.Mui-focused": { 
                                color: "#001f3f",
                                textTransform:"uppercase",
                                fontWeight:500
                            }, // Label color on focus
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: 10, // Field content size
                            color: "#333", // Field content color
                            "&::placeholder": {
                              color: "#aaa", // Placeholder color
                              fontSize: 10,
                            },
                          },
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: "2px",
                            "&.Mui-focused fieldset": { 
                                borderColor: "#001f3f",
                                borderRadius:"2px"
                            }, // Focus border
                          },
                          '& .MuiFormHelperText-root': {
                            fontSize: 9, // Smaller font size for validation errors
                            color: 'error.main', // Red color for errors
                            textTransform:"capitalize"
                          },
                        }}
                      />
                    </Grid>
        
                    {/* Submit Button */}
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        sx={{
                          borderRadius: "2px",
                          textTransform: 'none',
                          py: 1.5,
                          fontSize: 10,
                          boxShadow:0,
                          backgroundColor:"#001f3f",                  
                          "&:hover": {
                              boxShadow: "none",
                          },
                        }}
                      >
                        Add New FAQ
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Container>
            ):open.update?(
              <Container maxWidth="md">
                <IconButton
                    onClick={toggleDrawer("update", false)}
                >
                    <ArrowBack/>
                </IconButton>
              <Box
                sx={{
                  mt: "4px",
                  p: "4px",
                  // borderRadius: 2,
                  boxShadow: 0,
                  backgroundColor: 'background.paper',
                }}
              >
                <Typography variant="h4" sx={{ fontWeight: 700, color: "#001f3f", fontSize:12, textTransform:"uppercase" }}>
                  Edit Frequently Asked Question (Guides)
                </Typography>
                <Typography variant="body1" sx={{mb:2, color: "text.secondary", fontSize: 10, textTransform:"capitalize" }}>
                  Update the question and answer to keep the FAQ relevant.
                </Typography>
                <form onSubmit={upformik.handleSubmit}>
                  <Grid container spacing={3}>
                    {/* Title Field */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Question"
                        name="question"
                        // margin='normal'
                        value={upformik.values.question}
                        onChange={upformik.handleChange}
                        error={upformik.touched.question && Boolean(upformik.errors.question)}
                        helperText={upformik.touched.question && upformik.errors.question}
                        InputLabelProps={{
                          sx: {
                            color: "#555", // Default label color
                            fontSize: 10,
                            transition: "color 0.3s ease",
                            "&:hover": {
                                color: "#333"
                            }, // Label color on hover
                            "&.Mui-focused": { 
                                color: "#001f3f",
                                textTransform:"uppercase",
                                fontWeight:500
                            }, // Label color on focus
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: 10, // Field content size
                            color: "#333", // Field content color
                            "&::placeholder": {
                              color: "#aaa", // Placeholder color
                              fontSize: 10,
                            },
                          },
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: "2px",
                            "&.Mui-focused fieldset": { 
                                borderColor: "#001f3f",
                                borderRadius:"2px"
                            }, // Focus border
                          },
                          '& .MuiFormHelperText-root': {
                            fontSize: 9, // Smaller font size for validation errors
                            color: 'error.main', // Red color for errors
                            textTransform:"capitalize"
                          },
                        
                        }}
                      />
                    </Grid>
        
                    {/* Content Field */}
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        size='small'
                        label="Answer"
                        name="answer"
                        value={upformik.values.answer}
                        onChange={upformik.handleChange}
                        error={upformik.touched.answer && Boolean(upformik.errors.answer)}
                        helperText={upformik.touched.answer && upformik.errors.answer}
                        // margin="normal"
                        multiline
                        rows={4}
                        InputLabelProps={{
                          sx: {
                            color: "#555", // Default label color
                            fontSize: 10,
                            transition: "color 0.3s ease",
                            "&:hover": {
                                color: "#333"
                            }, // Label color on hover
                            "&.Mui-focused": { 
                                color: "#001f3f",
                                textTransform:"uppercase",
                                fontWeight:500
                            }, // Label color on focus
                          },
                        }}
                        inputProps={{
                          sx: {
                            fontSize: 10, // Field content size
                            color: "#333", // Field content color
                            "&::placeholder": {
                              color: "#aaa", // Placeholder color
                              fontSize: 10,
                            },
                          },
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: "2px",
                            "&.Mui-focused fieldset": { 
                                borderColor: "#001f3f",
                                borderRadius:"2px"
                            }, // Focus border
                          },
                          '& .MuiFormHelperText-root': {
                            fontSize: 9, // Smaller font size for validation errors
                            color: 'error.main', // Red color for errors
                            textTransform:"capitalize"
                          },
                        }}
                      />
                    </Grid>
        
                    {/* Submit Button */}
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        sx={{
                          borderRadius: "2px",
                          textTransform: 'none',
                          py: 1.5,
                          fontSize: 10,
                          boxShadow:0,
                          backgroundColor:"#001f3f",                  
                          "&:hover": {
                              boxShadow: "none",
                          },
                        }}
                      >
                        Update FAQ
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Container>
            ):(
              <Container>
                <List>
                <Typography variant="h2" component="h2" 
                sx={{ 
                    fontSize:12,
                    fontWeight:700,
                    textTransform:"uppercase"
                }}
                >
                    FAQs Management
                </Typography>
                <Typography variant="body1" component="h2" 
                sx={{ 
                    marginBottom: 2,
                    color: "text.secondary",
                    textTransform:"capitalize",
                    fontSize:10
                }}>
                    Add, edit, or delete frequently asked questions.
                </Typography>
            <Button
            startIcon={<Add/>}
            variant="contained"
            // color="primary"
            elevation={0}
            disableElevation={true}
            onClick={toggleDrawer("create", true)}
            sx={{ 
                mb: 1,
                color:"#001f3f",
                borderRadius:"1px",
                fontSize:10,
                fontWeight:500,
                textTransform:"capitalize",
                background:"none",
                textDecoration:"underline"
             }}
             >
               
               Click here to Add New FAQ
            </Button>
            <Typography variant="h4" component="h4" 
            sx={{ 
                mt:2,mb:1,
                fontSize:10,
                textTransform:"uppercase",
                fontWeight:600
                
                 }}>
                FAQS List
            </Typography>
                {faqs.map((faq) => (
                  <ListItem key={faq.id}>
                    <ListItemText primary={faq.question} secondary={faq.answer}
                      primaryTypographyProps={{
                        style: {
                          fontSize: 12, // Larger font size for the question
                          fontWeight: 'bold', // Bold text for the question
                          color: '#001f3f', // Dark blue color for the question
                          texttransform:"capitalize"
                        },
                      }}
                      secondaryTypographyProps={{
                        style: {
                          fontSize: 10, // Smaller font size for the answer
                          color: '#555', // Gray color for the answer
                          marginTop: '4px', // Add some space between question and answer
                        },
                      }} />
                      {/* Edit Button */}
                        <IconButton
                          onClick={() => handleOpenUpdateDrawer(faq)}
                          aria-label="edit"
                          color="inherit"
                        >
                          <Edit />
                        </IconButton>
                        {/* Delete Button */}
                        <IconButton
                          onClick={() => handleDelete(faq.id)}
                          aria-label="delete"
                          color="error"
                        >
                          <Delete />
                        </IconButton>
                  </ListItem>
                ))}
              </List>
              </Container>
            )
           
          )
        }
        
      </Box>
      <Box hidden={tabValue !== 1}>
        {
          userQuestions?.length === 0 ? (
            <Typography color='text.secondary' sx={{
              textTransform:"capitalize",
              fontSize:10,
              textAlign:"center"
            }}>No Data yet</Typography>
          ):(
            <List>
          {userQuestions.map((question) => (
            <ListItem sx={{
              display:"flex",
              flexDirection:"column",
              alignItems:"flex-start"
            }} key={question.id}>
              <ListItemText
              primaryTypographyProps={{
                style: {
                  fontSize: 12, // Larger font size for the question
                  fontWeight: 'bold', // Bold text for the question
                  color: '#001f3f', // Dark blue color for the question
                  texttransform:"capitalize"
                },
              }}
              secondaryTypographyProps={{
                style: {
                  fontSize: 10, // Smaller font size for the answer
                  color: '#555', // Gray color for the answer
                  marginTop: '4px', // Add some space between question and answer
                },
              }}
                primary={question.question}
                secondary={question.is_answered ? `Answered: ${question.answer}` : 'Not answered yet'}
              />
              {!question.is_answered && (
                <TextField
                fullWidth
                multiline
                rows={3}
                label="Answer"
                onBlur={(e) => handleAnswer(question.id, e.target.value)}
                margin="normal"
                InputLabelProps={{
                  sx: {
                    color: "#555", // Default label color
                    fontSize: 10,
                    transition: "color 0.3s ease",
                    "&:hover": {
                        color: "#333"
                    }, // Label color on hover
                    "&.Mui-focused": { 
                        color: "#001f3f",
                        textTransform:"uppercase",
                        fontWeight:500
                    }, // Label color on focus
                  },
                }}
                inputProps={{
                  sx: {
                    fontSize: 10, // Field content size
                    color: "#333", // Field content color
                    "&::placeholder": {
                      color: "#aaa", // Placeholder color
                      fontSize: 10,
                    },
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: "2px",
                    "&.Mui-focused fieldset": { 
                        borderColor: "#001f3f",
                        borderRadius:"2px"
                    }, // Focus border
                  },
                  '& .MuiFormHelperText-root': {
                    fontSize: 9, // Smaller font size for validation errors
                    color: 'error.main', // Red color for errors
                    textTransform:"capitalize"
                  },
                
                }}
                />
              )}
            </ListItem>
          ))}
        </List>

          )
        }
        
      </Box>
    </Paper>

    {/* Toast Notifications */}
    <Snackbar
      open={toast.open}
      autoHideDuration={3000}
      onClose={() => setToast({ open: false, message: "", severity: "" })}
    >
      <Alert severity={toast.severity} 
      sx={{
              fontSize: 10, // Adjust font size
              fontWeight:500, // Make text bold
              width: "100%",
              borderRadius: "1px", // Rounded corners
              padding: "10px", // Adjust padding 
              textTransform:"capitalize"
          }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
    </Container>
  )
}

export default Guide
